import ArticlePage from "@/pages/article/ArticlePage";

export default function BestBudgetFinds() {
  return <ArticlePage slug="best-budget-finds-under-30" />;
}